<template>
	<card layout="table" tag="section">
		<template #default>
			<loading v-if="loading"></loading>
			<company-table v-else :data="companies" :per-page="perPage"></company-table>
		</template>
	</card>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import companyTable from "@/components/tables/companyTable.vue";
	export default {
		components: { companyTable },
		props: {
			take: {
				type: [String, Number],
				default: 5
			},
			filters: {
				type: Object,
				default: () => {
					return {};
				}
			},
			perPage: {
				type: Number,
				default: 50
			}
		},

		setup(props, context) {
			const moment = inject("$moment");
			const $http = inject("$http");

			const loading = ref(true);
			const companies = ref([]);

			const isPaginated = computed(() => {
				return (companies?.value?.length || 0) > props.perPage;
			});

			const GetCompanies = async () => {
				loading.value = true;

				try {
					const response = await $http.post("/api/v2/widget/recentCompanies", {
						filter: props.filters?.keys || [],
						take: props.take || undefined
					});
					companies.value = response.data;
				} catch (err) {
					console.error(err);
				}

				loading.value = false;
			};

			onMounted(() => {
				GetCompanies();
			});

			return {
				moment,
				loading,
				companies,
				isPaginated
			};
		}
	};
</script>
